import $ from 'jquery';


export default class SlickSlider {
    init() {
        $('[data-slick]').not('.slick-initialized').each(function () {
            let self = $(this);
            if (self.data('count') === 1) {
                return;
            }
            self.slick({
                dots: true,
                arrows: false,
                // prevArrow:"<button type=\"button\" class=\"btn btn-link slick-prev slick-arrow\"><i class=\"material-icons left\">&#xE314;</i></button>",
                // nextArrow:"<button type=\"button\" class=\"btn btn-link slick-next slick-arrow\"><i class=\"material-icons right\">&#xE315;</i></button>"
            });
        });
    }
    initBrandSlider() {
        $('.brands-slider').slick({
            arrows: false,
            infinite: true,
            slidesToShow: 4,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            // prevArrow:"<button type=\"button\" class=\"btn btn-link slick-prev slick-arrow\"><i class=\"material-icons left\">&#xE314;</i></button>",
            // nextArrow:"<button type=\"button\" class=\"btn btn-link slick-next slick-arrow\"><i class=\"material-icons right\">&#xE315;</i></button>"
        });
    }
    initHomePageSlider() {
        var isMobile = window.matchMedia("only screen and (max-width: 768px)").matches;
        if (isMobile) {
            $( ".single-slider" ).each(function( index ) {

                $( this ).find('.slider-caption').appendTo($( this )); 
              });
        }

        var $homepageSlider = $('.homepage-slider');

        $homepageSlider.slick({
            arrows: true,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
           
            autoplay: true,
            autoplaySpeed: 6000,
            responsive: [
                {
                  breakpoint: 768,
                  settings: {
                    adaptiveHeight: true,
                    autoplay: false,
                  }
                },
             
              ],
            prevArrow: "<button type=\"button\" class=\"btn btn-link slick-prev slick-arrow\"><i class=\"icon-arrow left\"></i></button>",
            nextArrow: "<button type=\"button\" class=\"btn btn-link slick-next slick-arrow\"><i class=\"icon-arrow right\"></i></button>"
        });
     
    }

}